// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"486":"cb5b6ec0","659":"33c69ae3"}[chunkId] + ".chunk.js";
};